import { MARK_GRID, markFor } from '../icons/platform-marks';

/**
 * A platform's own logo, inline.
 *
 * **Deliberately not `<Icon>`.** The sprite is one set at one thickness and
 * `icon-sprite.mjs` exists to make reaching outside it awkward; these are
 * trademarks rather than pictures we drew, and a trademark redrawn at our
 * weight is a trademark we have altered. Keeping them out of `ICON_NAMES` means
 * somebody adding a picture to a screen cannot reach one by accident, which is
 * the property that rule is actually protecting.
 *
 * `currentColor`, so it takes the colour of whatever it is set in — the button's
 * label, the spine's ink — rather than carrying a brand colour of its own onto
 * our surfaces. Every platform's terms allow a single-colour rendering; several
 * of them require it on a coloured ground.
 *
 * Returns null for a name with no mark, so a store added to `store-links.ts`
 * before its logo arrives renders a button with a word on it rather than a hole.
 */
export function PlatformMark({
  name,
  size = 16,
}: {
  name: string;
  size?: number;
}): React.ReactElement | null {
  const art = markFor(name);
  if (art === null) return null;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${MARK_GRID} ${MARK_GRID}`}
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block', flex: 'none' }}
    >
      <path d={art.path} />
    </svg>
  );
}
